/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { FormEvent, useState } from "react";
import emailChangeStyle from "./emailChangeStyle";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import { Box, TextField } from "@mui/material";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { apiPost, getToken } from "@/src/services/apiClient";
import { addMessage } from "@/src/store/messages/actions";

type EmailChangeProps = {
  newEmail: string;
  handleClose: () => void;
};

export default function EmailChange({ newEmail, handleClose }: EmailChangeProps) {
  const { customer } = useCustomer();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (!customer) {
    return null;
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await getToken({
        email: customer.email,
        password: password,
      });
      apiPost("/new_email", { newEmail }).then(
        () => {
          addMessage({
            type: "success",
            text: "Sie erhalten in Kürze die E-Mail zur Bestätigung Ihrer neuen E-Mail-Adresse",
          });
        },
        () => {
          addMessage({
            type: "error",
            text: "Wir konnten Ihre Anfrage nicht bearbeiten. Sollte dieses Problem bestehen bleiben, wenden Sie sich bitte an unseren Kundendienst",
          });
        }
      );
      handleClose();
    } catch (e: any) {
      addMessage({
        type: "error",
        text: e.message,
      });
    }
  };

  return (
    <Box component={"form"} sx={emailChangeStyle.form} onSubmit={handleSubmit}>
      <p>Zu Ihrer Sicherheit: Bitte bestätigen Sie die Änderung der E-Mail-Adresse mit Ihrem Passwort.</p>
      <TextField
        fullWidth={true}
        type={showPassword ? "text" : "password"}
        label="Passwort"
        name="password"
        value={password}
        onChange={({ target }) => setPassword(target.value)}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }
        }}
      />
      <p>Sie müssen die neue E-Mail-Adresse noch bestätigen, bevor die Änderung endgültig übernommen wird. Hierzu erhalten Sie eine E-Mail von uns.</p>
      <ButtonLoading color="primary" variant="contained" type="submit" fullWidth isLoading={isLoading}>
        E-Mail-Adresse ändern
      </ButtonLoading>
    </Box>
  );
}
